import type { UiKey } from './en';

export const fr: Record<UiKey, string> = {
  'lang.label': 'Langue',

  'nav.residences': 'Résidences',
  'nav.mobility': 'Mobilité',
  'nav.retreats': 'Retraites',
  'nav.slClub': 'SL Club',
  'nav.privateLine': 'Private Line',
  'nav.membership': 'Adhésion',
  'nav.login': 'Connexion',
  'nav.menu': 'Menu',
  'nav.closeMenu': 'Fermer le menu',
  'nav.home': 'Superluxury — accueil',

  'menu.clientLine': 'Ligne client',
  'menu.clientLineNote': 'Un partenaire vous répond, à toute heure.',

  'announcement.text':
    'Les consultations privées sont désormais reçues dans nos nouveaux ateliers de Genève et de Dubaï.',
  'announcement.link': 'Demander une audience privée',
  'announcement.close': 'Fermer l’annonce',

  'hero.label': 'Découvrir Superluxury',
  'hero.srTitle': 'Venturist — une série d’événements privés signée Superluxury',
  'hero.tagline': 'Une série privée signée Superluxury. Sur invitation uniquement.',
  'hero.discover': 'Découvrir Venturist',
  'hero.scroll': 'Faire défiler',
  'hero.pause': 'Mettre le film en pause',
  'hero.play': 'Lire le film',

  'footer.help': 'Pouvons-nous vous aider ?',
  'footer.faq': 'Questions fréquentes',
  'footer.support': 'Assistance : anglais',
  'footer.house': 'La Maison',
  'footer.locator': 'Trouver un atelier',
  'footer.locatorPlaceholder': 'PAYS/RÉGION, VILLE',
  'footer.findAtelier': 'Trouver un atelier',
  'footer.lettersTitle': 'S’inscrire aux Lettres Superluxury',
  'footer.lettersBody':
    'Recevez des notes exclusives sur nos nouveaux services, des invitations personnelles et d’autres nouvelles de l’univers Superluxury.',
  'footer.lettersThanks': 'Merci. Vous recevrez la prochaine lettre.',
  'footer.email': 'E-mail',
  'footer.signUp': 'S’inscrire',
  'footer.emailError': 'Veuillez saisir une adresse e-mail valide.',
  'footer.country': 'Pays/Région',
  'footer.services': 'Services Superluxury',
  'footer.discoverServices': 'Découvrir nos services',
  'footer.seekIntro': 'Solliciter une introduction',
  'footer.destinations': 'Destinations',
  'footer.follow': 'Suivez-nous',
  'footer.rights': 'Tous droits réservés.',
};
